(function () {
  class FaqSupportWidget extends HTMLElement {
    connectedCallback() {
      this.toggleBtn = this.querySelector('[data-ref="toggle"]');
      this.closeBtn = this.querySelector('[data-ref="close"]');
      this.panel = this.querySelector('[data-ref="panel"]');
      this.searchInput = this.querySelector('[data-ref="search"]');
      this.listEl = this.querySelector('[data-ref="list"]');
      this.emptyEl = this.querySelector('[data-ref="empty"]');
      this.items = Array.prototype.slice.call(this.querySelectorAll('.faq-widget__item'));

      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', this.togglePanel.bind(this));
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', this.closePanel.bind(this));
      }

      if (this.searchInput) {
        this.searchInput.addEventListener('input', this.onSearch.bind(this));
      }

      this._onDocClick = this.onDocumentClick.bind(this);
      this._onKeydown = this.onKeydown.bind(this);
    }

    togglePanel() {
      var isOpen = this.hasAttribute('open');
      if (isOpen) {
        this.closePanel();
      } else {
        this.openPanel();
      }
    }

    openPanel() {
      this.setAttribute('open', '');
      if (this.panel) this.panel.hidden = false;
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this._onDocClick);
      document.addEventListener('keydown', this._onKeydown);

      // Only auto-focus the search box on devices with a real keyboard/mouse. On touch
      // devices, focusing it immediately pops up the on-screen keyboard, which combined
      // with the panel's viewport-relative height can push the close button out of reach.
      var supportsHoverFine =
        window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      if (this.searchInput && supportsHoverFine) {
        window.requestAnimationFrame(
          function () {
            this.searchInput.focus();
          }.bind(this)
        );
      }
    }

    closePanel() {
      this.removeAttribute('open');
      if (this.panel) this.panel.hidden = true;
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this._onDocClick);
      document.removeEventListener('keydown', this._onKeydown);
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.closePanel();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.closePanel();
        if (this.toggleBtn) this.toggleBtn.focus();
      }
    }

    onSearch(event) {
      var query = (event.target.value || '').trim().toLowerCase();
      var visibleCount = 0;

      this.items.forEach(function (item) {
        var text = item.textContent.toLowerCase();
        var matches = query === '' || text.indexOf(query) !== -1;
        item.hidden = !matches;
        if (matches) visibleCount++;
      });

      if (this.emptyEl) this.emptyEl.hidden = visibleCount !== 0;
    }
  }

  if (!customElements.get('faq-support-widget')) {
    customElements.define('faq-support-widget', FaqSupportWidget);
  }
})();
